import { render } from "./CandidateAttributes.vue?vue&type=template&id=8bc34c94"
import script from "./CandidateAttributes.vue?vue&type=script&lang=js"
export * from "./CandidateAttributes.vue?vue&type=script&lang=js"
script.render = render

export default script